/**
 *
 * AdministratorBCView actions
 *
 */

import {HANDLE_PARAMS_ACTION} from './constants';

export function handleParams(id) {
    return {
        type: HANDLE_PARAMS_ACTION,
        payload: {id},
    };
}
